<template lang="pug">
  .profile-page__main
    .profile-page__header
      .profile-page__title
        h1.title Настройка договора
    .profile-page__body
      .manager-contract
        ol.manager-contract__list
          li.manager-contract__item.manager-contract-item
            .manager-contract-item__title Выберите лагерь
            .manager-contract-item__body
              simple-select-form(
              :list-data="camps"
              :default-value="camp"
              @onChangeDefaultValue="changeCamp"
              :type="'camp'"
              :specificChoice="true"
              )
          li.manager-contract__item.manager-contract-item
            .manager-contract-item__title Скачайте&#32;
              a.link.bold(
              href="/documents/Шаблон договора.docx"
              target="_blank"
              ) шаблон договора
          li.manager-contract__item.manager-contract-item
            .manager-contract-item__title Ознакомьтесь с&#32;
              a.link.bold(
              href="/documents/Таблица тегов для договора и квитанций.docx"
              target="_blank"
              ) таблицей тегов
          li.manager-contract__item.manager-contract-item
            .manager-contract-item__title Заполните шаблон договора согласно таблице, а также укажите индивидуальные для вашего лагеря данные в пустых полях
          li.manager-contract__item.manager-contract-item
            .manager-contract-item__title Загрузите заполненный документ
            .manager-contract-item__body
              attach-file(
              :attachments="fields.contract"
              attachment-type="order_docs_contract"
              fieldname="contract"
              @onChangeAttachments="changeAttachments"
              :singleFile="true"
              )
          li.manager-contract__item.manager-contract-item
            .manager-contract-item__title Скачайте стандартный&#32;
              a.link.bold(
              href="/documents/Шаблон квитанции.docx"
              target="_blank"
              ) шаблон квитанции
          li.manager-contract__item.manager-contract-item
            .manager-contract-item__title Заполните шаблон квитанции согласно таблице,а также укажите наименование учреждения и реквизиты, актуальные для вашего лагеря

          li.manager-contract__item.manager-contract-item
            .manager-contract-item__title Загрузите заполненный документ
            .manager-contract-item__body
              attach-file(
              :attachments="fields.invoice"
              attachment-type="order_docs_invoice"
              fieldname="invoice"
              @onChangeAttachments="changeAttachments"
              :singleFile="true"
              )
          li.manager-contract__item.manager-contract-item
            .manager-contract-item__title Нажмите кнопку "Сохранить"
            .manager-contract-item__body
              button.button.button_paint-main.button_long(
              @click.prevent="onSaveCamp"
              ) Сохранить

</template>

<script>
import {mapState, mapActions} from "vuex";
import AttachFile from "../../../../../components/attach-file/AttachFile";
import SimpleSelectForm from "../../../../../components/simpleSelectForm/SimpleSelectForm";

export default {
  name: "ManagerContract",
  components: {SimpleSelectForm, AttachFile},
  data() {
    return {
      campData: null,
      camp: {
        text: "Выберите лагерь",
        value: null
      },
      fields: {
        contract: [],
        invoice: []
      }
    };
  },
  computed: {
    ...mapState(["userData"]),
    campId() {
      return this.userData.camp;
    },
    camps() {
      let arr = [
        {
          text: "Выберите лагерь",
          value: null
        }
      ];
      if (this.userData && this.userData.camps) {
        arr = this.userData.camps.map(item => {
          return {
            text: item.name,
            value: item.id
          };
        });
      }
      return arr;
    }
  },
  methods: {
    ...mapActions(["getCamp", "updateCamp"]),
    changeCamp(data) {
      this.camp = data;
    },
    setCamp() {
      this.camp = this.camps[0];
    },
    setFields() {
      this.fields.contract = this.campData.contract;
      this.fields.invoice = this.campData.invoice;
    },
    changeAttachments(data) {
      this.fields[data.fieldname] = data.value;
    },
    onSaveCamp() {
      const data = {
        contract: this.fields.contract.length > 0 ? this.fields.contract[0].id : null,
        invoice: this.fields.invoice.length > 0 ? this.fields.invoice[0].id : null
      };
      this.updateCamp({
        id: this.camp.value,
        data: data
      }).then(res => {
        if (res.status === 200) {
          this.campData = res.data;
          alert("Лагерь обновлен");
        } else {
          alert(res.status);
        }
      });
    }
  },
  mounted() {
    this.setCamp();
  },
  watch: {
    camp() {
      this.getCamp(this.camp.value).then(res => {
        if (res.status !== 404) {
          this.campData = res;
        }
      });
    },
    campData(val) {
      this.setFields(val);
    }
  }
};
</script>
